import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { Device } from '@ynomia/core/dist/device';
import { ActionFromPayloadMap } from '../config/types';
import DeviceReducer from '../reducers/devices';

export type DeviceStateType = {
  devicesKeyedById: Map<string, Device>
  isFetchingDevices: boolean
};

export type DeviceActionPayloadMap = {
  SET_DEVICES: Map<string, Device>;
  SET_FETCHING_DEVICES: boolean;
};

export type DeviceAction = ActionFromPayloadMap<DeviceActionPayloadMap>;

const initialState: DeviceStateType = {
  devicesKeyedById: new Map(),
  isFetchingDevices: false,
};

export const DeviceContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<DeviceAction>,
});

export const useDevice = (): [DeviceStateType, React.Dispatch<DeviceAction>] => {
  const { state, dispatch } = useContext(DeviceContext);
  return [state, dispatch];
};

export const DeviceProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(DeviceReducer, initialState);

  return (
    <DeviceContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </DeviceContext.Provider>
  );
};
